<template>
  <div>
    <div class="leftSideMenu">
      <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
        <el-menu
          :default-active="$route.path"
          router
          unique-opened
          :collapse="isCollapse"
        >
          <template v-for="(item, index) in mymenu">
            <!--存在子菜单-->
            <el-submenu v-if="item.children" :key="index" :index="item.path">
              <template slot="title">
                <svg-icon :iconClass="getIcon(item.icon)"></svg-icon>
                <span>{{ $t("sideMenu." + item.name) }}</span>
              </template>
              <template v-for="(subitem, subindex) in item.children">
                <el-menu-item
                  :key="subindex"
                  :index="subitem.path"
                  @click="handleOpen(subitem.path)"
                  v-if="routeAuth.indexOf(subitem.name) > -1"
                >
                  <span>
                    {{ $t("sideMenu." + subitem.name) }}
                  </span>
                </el-menu-item>
              </template>
            </el-submenu>
            <!--不存在子菜单-->
            <el-menu-item
              v-else
              :key="index"
              :index="item.path"
              @click="handleOpen(item.path)"
            >
              <!-- <template slot="title"> -->
                <svg-icon :iconClass="getIcon(item.icon)"></svg-icon>
                <span slot="title">{{ $t("sideMenu." + item.name) }}</span>
              <!-- </template> -->
            </el-menu-item>
          </template>
        </el-menu>
      </el-scrollbar>
    </div>
    <div class="collapseBtn">
      <i v-if="!isCollapse" class="el-icon-s-fold" @click="setCollapse()"></i>
      <i v-if="isCollapse" class="el-icon-s-unfold" @click="setCollapse()"></i>
    </div>
  </div>
</template>

<script>
import SvgIcon from "../../components/SvgIcon";
import myData from '../../layout/adapter';
export default {
  components: { SvgIcon },
  data() {
    return {};
  },
  computed: {
    mymenu: function () {
      // let route = {};
      // console.log(this.$store.getters.currentRoute.resCode);
      // this.$router.options.routes.forEach((item) => {
      //   if (item.name == this.$store.getters.currentRoute.resCode) {
      //     route = item.children;
      //   }
      // });
      // return route;
      return JSON.parse(myData);
    },
    isCollapse: function () {
      return this.$store.getters.collapse;
    },
    routeAuth: function () {
      return this.$store.getters.auth.routeAuth || [];
    },
  },
  created() {},
  methods: {
    getIcon(icon) {
      return icon || "default";
    },
    setCollapse() {
      this.$store.commit("common/SET_COLLAPSE", !this.isCollapse);
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },  },
};
</script>
<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 260px;
  min-height: 400px;
}
.leftSideMenu {
  height: calc(100% - 30px);
}
.collapseBtn {
  height: 30px;
}
::v-deep .el-menu--collapse {
  width: 50px;
}
.siderIcon {
  width: 31px;
  display: inline-block;
}
</style>
